<div class="d-flex justify-content-between align-items-center mg-b-5 font-12">
  <span>PLANNING FOURNISSEURS,
    @if (!utils.isCollectionNullOrEmpty(secteursFournisseurs)) { {{secteursFournisseurs.length}} fournisseur(s) }
  </span>
</div>

<dx-data-grid
  [dataSource]="secteursFournisseurs"
  keyExpr="id"
  width="100%"
  [height]="utils.scrollHeightContent(400)"
  [showBorders]="true"
  [showRowLines]="true"
  [rowAlternationEnabled]="true"
  [hoverStateEnabled]="true"
  [allowColumnResizing]="true"
  columnResizingMode="widget">

  <dxo-search-panel [visible]="true" [width]="200" placeholder="Rechercher..."></dxo-search-panel>
  <dxo-paging [enabled]="false"></dxo-paging>
  <dxo-pager [visible]="false"></dxo-pager>

  <dxi-column caption="" width="5%" [allowFiltering]="false" [allowSorting]="false"
              cellTemplate="actionsCellTemplate">
  </dxi-column>

  <dxi-column caption="Secteur Fournisseur" dataField="fournisseurLibelle" [allowSorting]="false"
              cellTemplate="sfCellTemplate">
  </dxi-column>

  <dxi-column caption="Code Client" width="8%" [allowFiltering]="false" [allowSorting]="false"
              cellTemplate="codeClientCellTemplate">
  </dxi-column>

  <dxi-column caption="Délai de commande" width="15%" [allowFiltering]="false" [allowSorting]="false"
              cellTemplate="delaiCellTemplate">
  </dxi-column>

  <dxi-column caption="Heure Limite" width="7%" [allowFiltering]="false" [allowSorting]="false"
              cellTemplate="heureLimiteCellTemplate">
  </dxi-column>

  @for (jourSemaine of joursSemaine; track jourSemaine.value) {
    <dxi-column
      [caption]="jourSemaine.viewValue"
      [allowFiltering]="false"
      [allowSorting]="false"
      width="7%"
      cellTemplate="jourCellTemplate">
    </dxi-column>
  }

  <!-- Actions -->
  <div *dxTemplate="let cell of 'actionsCellTemplate'">
    <yo-button iconClass="fas fa-clipboard"
               [theme]="ButtonThemeEnum.DEFAULT"
               (onClick)="openDialogRemarqueCommande(cell.data)"
               tooltip="Ajouter une remarque permanent pour vos commandes">
    </yo-button>
  </div>

  <!-- Secteur Fournisseur -->
  <div *dxTemplate="let cell of 'sfCellTemplate'">
    <span [title]="getSecteurFournisseurInfoLivraison(cell.data)" class="cursor">
      <yo-site [siteId]="cell.data.secteur.site.id"></yo-site>
      <span class="mg-r-5">{{cell.data.fournisseurLibelle}}</span>
      <span class="mg-r-5 genlabel">{{cell.data.secteur.libelle}}</span>
    </span>
    @if (!secteursFournisseurOfUDPSvc.secteurFournisseurActif(cell.data)) {
      <i class="fas fa-exclamation-triangle danger-color space cursor"
         [title]="getTooltipWarningFilialeInactive(cell.data)">
      </i>
    }
  </div>

  <!-- Code Client -->
  <div *dxTemplate="let cell of 'codeClientCellTemplate'">
    <dx-text-box
      [value]="getCodeClient(cell.data)"
      (onValueChanged)="onChangeCodeClient(cell.data, $event.value)"
      [width]="80"
      [disabled]="!this.gds.canModify(uniteDeProduction) || !canWrite">
    </dx-text-box>
  </div>

  <!-- Délai de commande -->
  <div *dxTemplate="let cell of 'delaiCellTemplate'" class="d-flex align-items-center gap-2">
    <span title="Délai de livraison en jour" class="cursorHelp" style="white-space:nowrap; min-width:65px; font-size:12px">
      @if (getDelaiLivraison(cell.data) === 0) { Jour même }
      @else if (getDelaiLivraison(cell.data) === 1) { {{getDelaiLivraison(cell.data)}} Jour }
      @else { {{getDelaiLivraison(cell.data)}} Jours }
    </span>
    <dx-slider
      [value]="getDelaiLivraison(cell.data)"
      [min]="0"
      [max]="30"
      [disabled]="!this.gds.canModify(uniteDeProduction) || !canWrite"
      (onValueChanged)="onChangeDelaiLivraison(cell.data, $event.value)"
      style="flex:1; min-width:60px">
    </dx-slider>
  </div>

  <!-- Heure Limite -->
  <div *dxTemplate="let cell of 'heureLimiteCellTemplate'">
    <yo-time-picker
      [value]="getHeureLimite(cell.data)"
      (onValueChange)="onChangeHeureLimite(cell.data, $event)"
      [disabled]="!this.gds.canModify(uniteDeProduction) || !canWrite"
      [popupTitle]="'Heure limite'">
    </yo-time-picker>
  </div>

  <!-- Jour de livraison — cell.columnIndex - 5 = index dans joursSemaine (5 colonnes fixes avant) -->
  <div *dxTemplate="let cell of 'jourCellTemplate'">
    <dx-check-box
      [value]="getAffectationValue(cell.data, joursSemaine[cell.columnIndex - 5])"
      (onValueChanged)="onChangeAffectation(cell.data, joursSemaine[cell.columnIndex - 5], {checked: $event.value})"
      [disabled]="!this.gds.canModify(uniteDeProduction) || !canWrite">
    </dx-check-box>
  </div>

</dx-data-grid>


<!--DIALOG COMMANDE REMARQUE-->
<yo-dialog-remarque-commande
  [canWrite]="canWrite">
</yo-dialog-remarque-commande>
